export const clearQuickFetchErrorsFromWindow = () => {
  delete window.hubspotQuickFetchErrors;
};
export const getQuickFetchErrorsFromWindow = () => window.hubspotQuickFetchErrors || [];
export const setQuickFetchErrorOnWindow = error => {
  window.hubspotQuickFetchErrors = [...getQuickFetchErrorsFromWindow(), error];
};